import { render, staticRenderFns } from "./Base_Type4.vue?vue&type=template&id=a0845118&scoped=true"
import script from "./Base_Type4.vue?vue&type=script&lang=js"
export * from "./Base_Type4.vue?vue&type=script&lang=js"
import style0 from "./Base_Type4.vue?vue&type=style&index=0&id=a0845118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0845118",
  null
  
)

export default component.exports